/**
 * 存放配置数据
 */
import globalConfig from '@utiles/globalConfig';

import Language from '../../store/languages';
Language.init();
const lang = Language.getAll();

export const USERACCOUNT = window.hasOwnProperty('user_account')
  ? window.user_account
  : globalConfig.getHrefParam('user_account');

export const LANG = globalConfig.getHrefParam('language') || 'en-US';

const mainHost = globalConfig.getMainHost();

export const BASEURL = {
  support: 'https://gsupport.' + mainHost || window.atob('MzdnYW1lcy5jb20='),
  passport: 'https://gpassport.' + mainHost || window.atob('MzdnYW1lcy5jb20='),
};

//   3syua.com => M3N5dWEuY29t   base64转换过来的
export const SYUA = 'M3N5dWEuY29t';

export const ZONE = window.hasOwnProperty('zone')
  ? window.zone
  : globalConfig.getHrefParam('zone');

export const API = {
  checkUserAccount: '/center/RepairAccount',
  fetchQuestList: '/center/repairAccount/get_all_question',
  fetchAreaList: '/repair/get_region_list',
  apply: '/repair/create_appeal',
  query: '/repair/query_appeal',
  add: '/repair/add_appeal',
  resetPwd: '/center/RepairAccount/resetPwd',
  sendEmailVerify: '/center/RepairAccount/sendResetEmailCode',
  resetEmail: '/center/RepairAccount/resetEmail',
  resetQuest: '/center/RepairAccount/resetQuestion',
  uploadImg: '/index/uploadImg',
  verifyCode: '/center/ajax/get_code?_=',
};

export const DEVICE = {
  PC: 'pc',
  MOBILE: 'mobile',
};

export const RESULT = {
  // query_appeal data.result / 外层业务态（与后端对齐）：
  // 0：接口失败（弹 msg，不走本表）
  // -1：资料审核中
  // -2：审核未通过；2：需补资料；3~7：见下
  query: {
    '-1': {
      title: lang.underReview,
      desc: lang.underReviewReply,
    },
    '-2': {
      title: lang.failed,
      desc: lang.reason,
      reason: {
        1001: lang.registerTimeError,
        1002: lang.bindEMailError,
        1003: lang.rechargeRecordError,
        1004: lang.registerIPError,
        1005: lang.deviceNumError,
        1006: lang.deviceModelError,
        1007: lang.reasonItemPwd,
      },
    },
    2: {
      title: lang.addInfo,
      desc: lang.underReviewAdd,
      reason: {
        2002: lang.addRegisterTime,
        2003: lang.addItemRegisterDate,
        2004: lang.addItemDeviceNumber,
        2005: lang.modelNumber,
        2006: lang.registrationIP,
        2007: lang.addRechargeRecord,
        2008: lang.addItemIDPhoto,
      },
    },
    3: {
      title: lang.addInfoSubmit,
      desc: '',
    },
    4: {
      title: lang.addOT,
      desc: '',
    },
    5: {
      title: lang.hasBeenRepaired,
      desc: '',
    },
    6: {
      title: lang.resetOT,
      desc: '',
    },
    7: {
      title: lang.approved,
      desc: '',
    },
  },
  'add:': {
    '-2': {
      title: lang.haveSubmitted,
      desc: '',
    },
    '-1': {
      title: lang.addOT,
      desc: '',
    },
    0: {
      title: lang.sessionExpired,
      desc: '',
    },
    1: {
      title: lang.submitted,
      desc: '',
    },
  },
  apply: {
    1: {
      title: lang.applicationSubmit,
      desc: lang.underReviewStatus,
      tips: lang.enterReviewIDNPwd,
    },
  },
};
